import Storage from '../../../storage';

function clear(): void {
    Storage.clearTable('history');
}

export {
    clear
};
